module.exports = "/_next/static/resources/photo-4-d803eff558427f8a8782fb8ace220c77.jpg";